module.exports = __webpack_public_path__ + "static/img/BiazfanxmamNRoxxVxka.fda3837.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/BiazfanxmamNRoxxVxka.png
// module id = UidD
// module chunks = 1